import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'defaultFilter'
})
@Injectable({
  providedIn: 'root'
})
export class DefaultFilterPipe implements PipeTransform {

  transform(items: any[], fields: string, search: string): any[] {
    if (!items) return [];
    if (!search) return this.sortEvents(items);

    const normalize = (str: string) =>
      str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    const fieldList = fields.split(',').map(f => f.trim()).filter(f => f);
    const normalizedSearch = normalize(search);

    return this.sortEvents(
      items.filter(item => {
        let combined = '';

        for (const field of fieldList) {
          const value = this.getNestedValue(item, field);
          combined += ' ' + this.collectStrings(value, 6, new WeakSet<object>());
        }

        return normalize(combined).includes(normalizedSearch);
      })
    );
  }

  private getNestedValue(obj: any, path: string): any {
    return path.split('.').reduce((acc, part) => acc && acc[part], obj);
  }

  // Coleta recursiva (profundidade limitada + guarda de ciclos via WeakSet) de todos os
  // valores string/número dentro de `value`. Permite que um campo aponte p/ um array
  // aninhado (ex.: `authors` → user → profile → affiliation) e ainda assim casar por nome,
  // e-mail e afiliação, não só por campos escalares no topo. Campos escalares retornam de
  // imediato, então os usos existentes (só escalares) não mudam de comportamento.
  private collectStrings(value: any, depth: number, seen: WeakSet<object>): string {
    if (value == null || depth < 0) { return ''; }
    const t = typeof value;
    if (t === 'string') { return value; }
    if (t === 'number' || t === 'boolean') { return String(value); }
    if (t !== 'object') { return ''; }
    if (seen.has(value)) { return ''; }
    seen.add(value);
    const entries = Array.isArray(value) ? value : Object.values(value);
    return entries.map(v => this.collectStrings(v, depth - 1, seen)).join(' ');
  }

  private sortEvents(events: any[]): any[] {
    return events.sort((a, b) => {
      if (b.year !== a.year) {
        return b.year - a.year;
      }
      return b.id - a.id;
    });
  }
}
